import { isIpad } from "shared/constants";

export default {
  color: {
    primary: "#1554A3",
    secondary: "#0078c7",
    link: "#6f8fff",
    background: "#ffffff",
    newBackgroundText: "#dfe8f4",
    backgroundText: "#919090",
    scrollBackground: "#f2f0ef",
    lightGrey: "#f5f5f5",
    grey: "#eaeaea",
    greyHighlight: "#d3d3d3",
    greyDarkHighlight: "#dbdbdb",
    text: "#0b4281",
    error: "#d40202",
    success: "#2ac734",
    disabled: "#bababa",
    darkGrey: "#7d7f80",
    black: "#454545",
    red: "#a8070c",
    alertRed: "#d30000",
    yellow: "#ecad41",
    green: "#0ead69",
    darkGreen: "#0a7c4d",
    hunterGreen: "#355E3B",
    white: "#f7f7f7",
    tableHeader: "#64778A",
    toast: {
      info: "#44c8e5",
      warning: "#ecad41",
      error: "#d36149",
      success: "#8ad25e",
    },
    organization: {
      red: "#a8070c",
      orange: "#fc7f03",
      yellow: "#d9b511",
      green: "#0ead69",
      blue: "#1982c4",
      pink: "#de0bbb",
      purple: "#7700b3",
      brown: "#754c00",
      black: "#333233",
    },
  },
  opacity: {
    disabled: 0.5,
  },
  font: {
    size: {
      header: isIpad ? 28 : 22,
      subHeader: isIpad ? 20 : 18,
      modalHeader: isIpad ? 28 : 17,
      body: isIpad ? 18 : 16,
      textEditorBody: isIpad ? 18 : 16,
      small: isIpad ? 14 : 13,
      standard: isIpad ? 18 : 14,
      large: isIpad ? 22 : 15,
      tableBody: isIpad ? 16 : 12,
      webviewHeader: isIpad ? 28 : 20,
      fontSize: isIpad ? 22 : 16,
    },
    weight: {
      bold: "700",
      semibold: "600",
      medium: "500",
      regular: "400",
    },
  },
  icon: {
    size: {
      status: isIpad ? 18 : 14,
      compact: isIpad ? 20 : 16,
      small: isIpad ? 22 : 18,
      regular: isIpad ? 24 : 20,
      medium: isIpad ? 26 : 22,
      large: isIpad ? 30 : 25,
      fab: isIpad ? 32 : 26,
      xlarge: isIpad ? 36 : 30,
      hero: isIpad ? 38 : 32,
      avatar: isIpad ? 42 : 35,
      upload: isIpad ? 70 : 60,
    },
  },
  image: {
    banner: isIpad ? 300 : 250,
  },
  card: {
    border: {
      width: isIpad ? 4 : 2,
      radius: isIpad ? 20 : 10,
      color: "#0078c7",
    },
  },
  position: {
    header: isIpad ? 82 : 50,
  },
  shadow: {
    bottomElevation2:
      "-1px 5px 9px -6px rgb(0 0 0 / 15%), 0px 2px 1px -1px rgb(0 0 0 / 10%)",
    topElevation2:
      "-1px -5px 9px -6px rgb(0 0 0 / 15%), 0px -2px 1px -1px rgb(0 0 0 / 10%)",
  },
};
